import { baseTheme } from '~base-theme';
var commerceTheme = {
  commerce: {
    thankYou: {
      logo: {
        width: 190
      }
    },
    productTemplate: {
      bgStart: '#f1f1f1',
      bgEnd: '#f1f1f1'
    },
    adsBanner: {
      fontFamily: 'inherit',
      container: {
        border: baseTheme.base.grays.grayLightest
      }
    }
  }
};
export default commerceTheme;